import { Instagram, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { NAV_LINKS } from "../mock";

export default function Footer({ theme = "light" }) {
  const dark = theme === "dark";
  const muted = dark ? "text-[#928c7d]" : "text-[#8b8578]";
  const line = dark ? "border-[rgba(236,231,219,0.16)]" : "border-[rgba(35,33,28,0.14)]";
  const ink = dark ? "text-[#ece7db]" : "text-[#23211c]";
  const hover = dark ? "hover:text-[#ece7db]" : "hover:text-[#23211c]";

  return (
    <footer className={`w-full ${ink}`}>
      <div className={`max-w-[1600px] mx-auto px-6 md:px-10 border-t ${line}`}>
        {/* Navigation row: MP wordmark left, links right */}
        <div className={`py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6 border-b ${line}`}>
          <Link to="/" className="group leading-none" aria-label="Medium Plenty — Home">
            <div className="font-display text-[26px] md:text-[30px] leading-none tracking-tight">Medium Plenty</div>
            <div className={`font-label text-[9px] mt-2 ${muted} ${hover} transition-colors`}>Architecture + Interiors</div>
          </Link>

          <nav className="flex items-center gap-8">
            {NAV_LINKS.map((l) => (
              <Link key={l.to} to={l.to} className={`font-label text-[11px] ${muted} ${hover} link-underline transition-colors`}>
                {l.label}
              </Link>
            ))}
            <a
              href="https://www.mediumplenty.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-full-site-link"
              className={`font-label text-[11px] inline-flex items-center gap-1 ${muted} ${hover} link-underline transition-colors`}
            >
              Full Site <ArrowUpRight className="w-3 h-3" strokeWidth={1.5} />
            </a>
          </nav>
        </div>

        {/* Meta row */}
        <div className="py-6 flex flex-col md:flex-row items-center justify-between gap-5">
          <div className={`font-label text-[10px] ${muted} order-2 md:order-1`}>&copy; 2026 Medium Plenty</div>

          <div className="flex items-center gap-6 order-1 md:order-2">
            <div className="text-center leading-none">
              <div className={`font-label text-[7px] ${muted} mb-1`}>Featured on</div>
              <div className="font-label text-[15px] font-medium tracking-[0.08em]">ARCHIPRO</div>
            </div>
            <a
              href="https://www.instagram.com/mediumplenty/"
              target="_blank"
              rel="noopener noreferrer"
              className={`${muted} ${hover} transition-colors`}
              aria-label="Instagram"
            >
              <Instagram className="w-4 h-4" strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
